import { Component, Input } from '@angular/core';
import { IInvoiceModel } from 'src/app/shared/models/credential/invoice.model';

@Component({
  selector: 'app-application-confirmation-payment',
  templateUrl: './application-confirmation-payment.component.html',
  styleUrls: ['./application-confirmation-payment.component.scss'],
})
export class ApplicationConfirmationPaymentComponent {
  @Input({ required: true }) invoice: IInvoiceModel;
  @Input() checkInstructions: string;
  @Input({ required: true }) isConfirmationPage: boolean;
  @Input() displayTableOnly: boolean = false;

  getTotalDisplay() {
    return {
      amount: this.invoice.paymentInvoiceLineItems.reduce(
        (acc: number, item: any) => acc + item.amount,
        0
      ),
      label: 'Total',
    };
  }

  get transactionDateLabel() {
    return this.invoice.paymentType ? 'Transaction Date' : 'Invoice Generated';
  }
  get orderNumberLabel() {
    return this.invoice.paymentType ? 'Invoice Number' : 'Order Number';
  }
}
